// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"531":"480935a6","874":"9bc6e702"}[chunkId] + ".chunk.js";
};